/* eslint-disable import/no-named-as-default-member */
import PaymentAnalytics from 'app/src/payments/PaymentAnalytics';
import { createReactRenderer } from 'helpers/react-renderer';
import TerminalPaymentModal from './components/TerminalPaymentModal';

// eslint-disable-next-line
let _terminalPaymentModal = null;

export default class TerminalPayment {
  static doTerminalPayment({
    initialAmount,
    terminal,
    saleManager,
    paymentProvider,
    recoveredPayment,
    isManualEntry,
    isUnreferencedRefund,
    refundedPaymentID,
    tipAmount = null,
  }) {
    return new Promise(terminalPaymentResolve => {
      const RenderedComponent = createReactRenderer({
        component: TerminalPaymentModal,
        selector: '[data-react-root="ReactModal"]',
        props: {
          analyticsName: PaymentAnalytics.Events.TERMINAL,
          initialAmount,
          terminal,
          paymentProvider,
          saleManager,
          recoveredPayment,
          isManualEntry,
          isUnreferencedRefund,
          refundedPaymentID,
          onHide: () => {
            _terminalPaymentModal = null;
            RenderedComponent.unmount();
            terminalPaymentResolve();
          },
          onPaymentComplete: () =>
            new Promise((resolve, reject) => {
              saleManager
                .refreshSale()
                .done(() => {
                  resolve();
                })
                .fail(() => {
                  reject('Failed to refresh the sale.');
                })
                .always(() => {
                  window.merchantos.register.donePay();
                });
            }),
          ...(tipAmount && { tipAmount }),
        },
      });
      _terminalPaymentModal = RenderedComponent.mount();
    });
  }
}
